import React from "react";
import type { AxisScale } from "../../lib/scale";
import { PLOT_LAYOUT, dataToSvg } from "../../lib/scale";

type GridLinesProps = {
  xScale: AxisScale;
  yScale: AxisScale;
};

const GRID_COLOR = "rgba(176,196,232,0.08)";

const GridLines: React.FC<GridLinesProps> = ({ xScale, yScale }) => {
  const { left, top, plotWidth, plotHeight } = PLOT_LAYOUT;

  return (
    <g>
      {/* 垂直線 (X 軸の ticks) */}
      {xScale.ticks.map((tick) => {
        const x = dataToSvg(tick, xScale, left, left + plotWidth);
        return (
          <line
            key={`xg-${tick}`}
            x1={x}
            y1={top}
            x2={x}
            y2={top + plotHeight}
            stroke={GRID_COLOR}
            strokeWidth={1}
          />
        );
      })}

      {/* 水平線 (Y 軸の ticks) */}
      {yScale.ticks.map((tick) => {
        const y = dataToSvg(tick, yScale, top + plotHeight, top);
        return (
          <line
            key={`yg-${tick}`}
            x1={left}
            y1={y}
            x2={left + plotWidth}
            y2={y}
            stroke={GRID_COLOR}
            strokeWidth={1}
          />
        );
      })}
    </g>
  );
};

export default GridLines;
